// extracted by mini-css-extract-plugin
module.exports = {"container":"idt-inlinegiftdesignerui_container__3vg4v","pinnedVariablesGrid":"idt-inlinegiftdesignerui_pinnedvariablesgrid__2mhv7"};